export const hotelMealType = {
  none: "None",
  breakfast: "Free breakfast",
};
